angular.module('core')
    .filter('percentage', function ($filter) {
        return (input, decimals) => $filter('number')(input, decimals) + '%';
    })
    .component('percentage', {
        bindings: {
            value: '<',
            total: '<',
            decimals: '<?',
            showZero: '<?',
            showAccurate: '<?'
        },
        template: '<span ng-if="($ctrl.value != null && $ctrl.value !== 0) || $ctrl.showZero === true"><span ng-if="$ctrl.showAccurate === true && !$ctrl.isAccuratePercentage($ctrl.percentage) && !$ctrl.equals()">~</span><span ng-if="$ctrl.percentage < 0">&nbsp;</span>{{$ctrl.percentage | percentage: $ctrl.decimals}}</span>',
        controller: function () {
            this.$onChanges = function () {
                this.decimals = this.decimals == null ? 0 : this.decimals;
                this.showZero = this.showZero == null ? true : this.showZero;
                this.showAccurate = this.showAccurate == null ? false : this.showAccurate;
                this.percentage = this.value / this.total * 100;
            }
            this.equals = () => {
                return this.value === this.total
            }
            this.isAccuratePercentage = (value) => {
                let value1 = Math.round(value * 10000000) / 10000000
                let value2 = Math.round(value)
                return value1 === value2
            }
        }
    })
